/* A Leading Role - Front Row in the navigation.
 *
 * Two jobs:
 *   1. a "Front Row" nav item for signed-in MEMBERS, with a small hover card
 *      showing their points, what those are worth, and a way through to the
 *      full panel at /pages/front-row
 *   2. a "Front Row Membership" link in the footer's Customer Care list, for
 *      EVERYONE - non-members land on the sales page, members on their panel
 *
 * Membership for (1) is read from #c-frontrow-data, which layout/theme.liquid
 * renders server-side from customer.tags, so the nav item is in the DOM on the
 * first paint and the menu never visibly grows an extra link. The numbers in
 * the card arrive a moment later from the Worker; until they do (or if the
 * request fails) the item is simply a plain link, exactly like its neighbours.
 *
 * Additive: sections/alr-header.liquid and sections/alr-footer.liquid are both
 * left untouched. That is deliberate for the footer especially - it also holds
 * the #c-customer-data JSON the Concierge depends on, and is edited by other
 * work, so a line is inserted here rather than the file being rewritten.
 *
 * The hover card is NOT a .mega panel. Those are a CSS grid built for image
 * tiles (.mimg / .mlogo / .mtile, sized by --mcols); a readout of someone's
 * balance belongs in something of its own, so this carries its own classes and
 * its own styles and inherits none of that.
 */
(function () {
  var LABEL = 'Front Row';
  var HREF = '/pages/front-row';
  var AFTER = '/collections/best-sellers'; // sits with the shopping links
  var ENDPOINT = '/apps/concierge/membership/status';

  var CREAM = '#FBF7F0';
  var GOLD = '#E3BE45';
  var SOFT = '#D9C6C9';

  function isMember() {
    try {
      var raw = document.getElementById('c-frontrow-data');
      if (!raw) return false;
      var data = JSON.parse(raw.textContent);
      return !!(data && data.member);
    } catch (err) {
      return false;
    }
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }

  function money(cents) {
    return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function num(n) {
    return String(Number(n || 0)).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }

  function shortDate(iso) {
    try {
      return new Date(iso).toLocaleDateString(undefined, { month: 'short', year: 'numeric' });
    } catch (err) {
      return '';
    }
  }

  function styles() {
    if (document.getElementById('fr-nav-style')) return;
    var s = document.createElement('style');
    s.id = 'fr-nav-style';
    s.textContent = [
      '.fr-nav{position:relative}',
      // Hidden by default; revealed on hover and on keyboard focus, with a
      // short delay-free fade so it does not feel sticky in passing.
      '.fr-pop{position:absolute;top:100%;left:50%;transform:translate(-50%,6px);',
      'width:264px;padding:16px 18px 15px;border-radius:5px;z-index:9999;',
      'background:linear-gradient(165deg,#5B1220,#3E0C16);color:' + CREAM + ';',
      'box-shadow:0 14px 34px rgba(0,0,0,.34);border:1px solid rgba(227,190,69,.32);',
      // The navbar sets uppercase + letter-spacing on its items and the card
      // would inherit both, which turns the sentence below into shouting.
      // Reset here; the bits that SHOULD be uppercase say so themselves.
      'font-family:Georgia,serif;text-align:left;text-transform:none;letter-spacing:normal;',
      'opacity:0;visibility:hidden;pointer-events:none;transition:opacity .16s ease,transform .16s ease}',
      '.fr-nav:hover .fr-pop,.fr-nav:focus-within .fr-pop{opacity:1;visibility:visible;pointer-events:auto;transform:translate(-50%,0)}',
      // A transparent bridge so the card does not vanish while the pointer
      // crosses the gap between the nav item and the card.
      '.fr-pop::before{content:"";position:absolute;left:0;right:0;top:-10px;height:10px}',
      '.fr-pop-k{font-size:9.5px;letter-spacing:.2em;text-transform:uppercase;color:' + GOLD + ';margin-bottom:11px}',
      '.fr-pop-figs{display:flex;gap:14px;margin-bottom:12px}',
      '.fr-pop-figs>div{flex:1}',
      '.fr-pop-figs .v{display:block;font-size:22px;line-height:1.1;color:' + GOLD + '}',
      '.fr-pop-figs .k{display:block;margin-top:3px;font-size:9px;letter-spacing:.14em;text-transform:uppercase;color:' + SOFT + '}',
      '.fr-pop-track{height:5px;border-radius:99px;background:rgba(227,190,69,.26);overflow:hidden}',
      '.fr-pop-track i{display:block;height:100%;border-radius:99px;background:' + GOLD + ';width:0;transition:width .6s ease}',
      '.fr-pop-meta{margin-top:9px;font-size:10.5px;line-height:1.5;color:' + SOFT + '}',
      '.fr-pop-cta{display:block;margin-top:13px;padding:9px 0;text-align:center;border:1px solid ' + GOLD + ';',
      'border-radius:3px;font-size:10px;letter-spacing:.14em;text-transform:uppercase;',
      'color:' + GOLD + ';text-decoration:none;transition:.16s}',
      '.fr-pop-cta:hover{background:' + GOLD + ';color:#3E0C16}',
      '@media (max-width:900px){.fr-pop{display:none}}'
    ].join('');
    document.head.appendChild(s);
  }

  function card(d) {
    styles();
    var pop = el('div', 'fr-pop');

    pop.appendChild(el('div', 'fr-pop-k', '✦ Your Front Row'));

    var figs = el('div', 'fr-pop-figs');
    var a = el('div');
    a.appendChild(el('span', 'v', num(d.points)));
    a.appendChild(el('span', 'k', 'Points'));
    var b = el('div');
    b.appendChild(el('span', 'v', money(d.pointsValueCents)));
    b.appendChild(el('span', 'k', 'Worth'));
    figs.appendChild(a);
    figs.appendChild(b);
    pop.appendChild(figs);

    var floor = Number(d.minRedeemPoints || 500);
    var step = Number(d.redeemStepPoints || 100);
    var pct = d.points < floor
      ? (d.points / floor) * 100
      : ((d.points % step) / step) * 100;

    var track = el('div', 'fr-pop-track');
    var fill = el('i');
    track.appendChild(fill);
    pop.appendChild(track);
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        fill.style.width = Math.max(0, Math.min(100, pct)) + '%';
      });
    });

    var meta = d.pointsToNext > 0
      ? num(d.pointsToNext) + ' points to your next ' + money(step)
      : money(d.redeemableValueCents) + ' ready to use';
    if (d.renewsAt) meta += ' · through ' + shortDate(d.renewsAt);
    pop.appendChild(el('div', 'fr-pop-meta', meta));

    var cta = el('a', 'fr-pop-cta', 'See your Front Row');
    cta.setAttribute('href', HREF);
    pop.appendChild(cta);

    return pop;
  }

  function navItem() {
    var li = el('li', 'fr-nav');
    li.setAttribute('data-fr-nav', '1');
    var a = el('a', null, LABEL);
    a.setAttribute('href', HREF);
    li.appendChild(a);
    return li;
  }

  // After Best Sellers when that link is there, otherwise at the end, so a
  // future reshuffle of the menu cannot drop it on the floor.
  function insertAfterBestSellers(list, li) {
    var links = list.querySelectorAll(':scope > li > a[href]');
    for (var i = 0; i < links.length; i++) {
      if (links[i].getAttribute('href').indexOf(AFTER) !== -1) {
        var anchor = links[i].parentNode;
        if (anchor.nextSibling) list.insertBefore(li, anchor.nextSibling);
        else list.appendChild(li);
        return;
      }
    }
    list.appendChild(li);
  }

  function addNav() {
    if (!isMember()) return;

    var main = document.querySelector('.masthead .navbar > ul');
    var desktopItem = null;
    if (main && !main.querySelector('[data-fr-nav]')) {
      desktopItem = navItem();
      insertAfterBestSellers(main, desktopItem);
    }

    var mobile = document.querySelector('#mobile-nav > ul');
    if (mobile && !mobile.querySelector('[data-fr-nav]')) {
      var m = el('li');
      m.setAttribute('data-fr-nav', '1');
      var ma = el('a', null, LABEL);
      ma.setAttribute('href', HREF);
      m.appendChild(ma);
      insertAfterBestSellers(mobile, m);
    }

    if (!desktopItem) return;

    // The numbers are the only part that needs the network. If this fails the
    // nav item stays a plain link rather than showing an empty card.
    fetch(ENDPOINT, { credentials: 'same-origin', cache: 'no-store' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        if (!d || !d.signedIn || !d.member) return;
        desktopItem.appendChild(card(d));
      })
      .catch(function () {});
  }

  // Footer: everyone gets this one. Non-members land on the sales page,
  // members on their own panel - it is the same URL either way.
  function addFooterLink() {
    var lists = document.querySelectorAll('footer .flinks details');
    for (var i = 0; i < lists.length; i++) {
      var head = lists[i].querySelector('summary h4');
      if (!head || head.textContent.trim().toLowerCase() !== 'customer care') continue;

      var ul = lists[i].querySelector('ul');
      if (!ul || ul.querySelector('[data-fr-footer]')) return;

      var li = el('li');
      var a = el('a', null, 'Front Row Membership');
      a.setAttribute('href', HREF);
      a.setAttribute('data-fr-footer', '1');
      li.appendChild(a);
      ul.insertBefore(li, ul.firstChild);
      return;
    }
  }

  function start() {
    addNav();
    addFooterLink();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
